<script setup lang="ts">
import { DateComp } from '@/components';

const props = defineProps<{ value: { First: Date | null; Last: Date | null } }>();
</script>
<template>
    <span>
        <DateComp
            :value="value.First"
            format="TIME"
        />
        -
        <DateComp
            :value="value.Last"
            format="TIME"
        />
    </span>
</template>
